import { useId } from 'react';

/**
 * The mark: a D with a tick struck through it — the letter, and the thing the product exists to
 * let someone say about their taxes.
 *
 * Drawn, not typed. It used to be a «Д» set in the system font inside a gradient box, which meant
 * the logo was whatever Segoe UI or Roboto happened to make of that letter, and a different shape
 * again in the favicon. One path now, the same in the sidebar, the sign-in page, the marketing
 * header and `public/favicon.svg` — keep that file in step when this changes.
 */
export function BrandMark({ size = 28 }: { size?: number }) {
  // Gradients are referenced by id, and ids are document-wide: two marks on one page (header and
  // footer of the landing shell) would otherwise both point at whichever was defined first.
  const id = useId();

  return (
    <svg
      className="brand-mark"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={`${id}-g`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#8372ff" />
          <stop offset="0.55" stopColor="#5b4be6" />
          <stop offset="1" stopColor="#312e81" />
        </linearGradient>
        <radialGradient id={`${id}-s`} cx="0.25" cy="0" r="1">
          <stop offset="0" stopColor="#fff" stopOpacity="0.38" />
          <stop offset="0.6" stopColor="#fff" stopOpacity="0" />
        </radialGradient>
      </defs>

      <rect width="32" height="32" rx="9" fill={`url(#${id}-g)`} />
      <rect width="32" height="32" rx="9" fill={`url(#${id}-s)`} />
      <rect
        x="0.5"
        y="0.5"
        width="31"
        height="31"
        rx="8.5"
        fill="none"
        stroke="#fff"
        strokeOpacity="0.2"
      />

      <path fill="#fff" d="M9 10.1a1.6 1.6 0 0 1 1.6-1.6h5.6a7.5 7.5 0 0 1 0 15h-5.6A1.6 1.6 0 0 1 9 21.9z" />
      <path
        d="m12.6 16.3 2.5 2.5 4.6-5.3"
        fill="none"
        stroke="#5546dd"
        strokeWidth="2.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
